import React, { useEffect } from 'react';
import cn from 'classnames';
import TextField, {
  TextFiledType,
} from '../../../../../../../components/common/textField';
import { Visibility } from '../../../../../../../types/common-types';
import { useDidMount } from '../../../../../../../components/common/effects';
import './style.scss';

interface ValueProps {
  id: string;
  value: string;
  error: boolean;
}
interface Props {
  id: string;
  title?: string;
  value?: string;
  extra?: { length: number };
  error?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  regexp?: string;
  required?: boolean;
  errorMsg?: string;
  helpMsg?: string;
  type?: TextFiledType;
  visibility?: Visibility;
  length?: number;
  onSubmit: (id: string) => void;
  onChange: (value: ValueProps, callback?: () => void) => void;
  submitOnChange?: boolean;
  nonPasteable?: boolean;
}

const Edit: React.FC<Props> = ({
  id,
  title,
  value = '',
  visibility,
  type,
  extra = {},
  required,
  placeholder,
  regexp,
  errorMsg,
  helpMsg,
  error,
  onChange,
  onSubmit,
  submitOnChange = false,
  nonPasteable = false,
}) => {
  const didMount = useDidMount();
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (didMount && submitOnChange) onSubmit(id);
    }, 100);
    return () => clearTimeout(timeout);
  }, [value]);
  return (
    <TextField
      id={id}
      className="edit"
      styleName={cn('edit')}
      type={type}
      label={title}
      visibility={visibility}
      value={value}
      error={error}
      placeholder={placeholder}
      required={required}
      regexp={regexp}
      length={extra.length}
      helperText={error ? errorMsg : helpMsg}
      onChange={onChange}
      nonPasteable={nonPasteable}
    />
  );
};
export default Edit;
